export const toggleModal = (flag, modal) =>{
        return {
            type: 'TOGGLE_MODAL',
            flag,
            modal
        }
};